import { useTranslation } from 'react-i18next'

import { performDocumentsMassAction } from '../../../../../api'
import { EMPTY_OBJECT } from '../../../../../constants/common'
import { FILE_SCOPE_USER } from '../../../../../constants/file'
import { SUBMENU_ALL_SECTION } from '../../../../../constants/route'
import { getAsyncTaskId } from '../../../../../utils/async'
import { ConfirmationModal } from '../../../../Confirmation'
import { DOCUMENTS_ACTION_DOWNLOAD } from '../../../../Document'
import { useFilesDownloadAll } from '../../../../File'
import { useUserProfileContext } from '../../../../User'

export function useUserProfilePageDownloadAllFilesAction() {
  const { t } = useTranslation()

  const { handleCloseModal, setModal, userData } = useUserProfileContext()

  const directoryId = userData?.directory_id

  const { handleErrorDownload, handleStartCheckStatus } = useFilesDownloadAll({
    onCloseModal: handleCloseModal,
    onSetModal: setModal,
  })

  function handleStartDownloadAll() {
    handleCloseModal()

    performDocumentsMassAction({
      data: {
        action: DOCUMENTS_ACTION_DOWNLOAD,
        all: true,
        filters: { parent: directoryId, sub_menu: SUBMENU_ALL_SECTION },
        object_id: String(userData?.id),
        payload: EMPTY_OBJECT,
        scope: FILE_SCOPE_USER,
      },
    })
      .then(({ data, status }) => {
        const asyncTask = getAsyncTaskId(data)

        if (asyncTask) {
          handleStartCheckStatus(asyncTask, status)
        }
      })
      .catch(handleErrorDownload)
  }

  function handleClickDownloadAll() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{ submitText: t('Modal.DownloadAllFilesBtnKey') }}
        description={t('Modal.AttentionFilesDownloadMessageKey')}
        onCancel={handleCloseModal}
        onSubmit={handleStartDownloadAll}
      />
    )
  }

  return {
    handleClickDownloadAll,
  }
}
